// Display-only date formatting for read views. Built-in Intl only — no date library.
// Payment dates are stored at UTC midnight, so format in UTC or the day slips back
// one for anyone west of Greenwich.
const DATE_FORMAT = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  timeZone: 'UTC',
});

export function formatIsoDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return DATE_FORMAT.format(d);
}
